/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./luckygiftorder.vue?vue&type=template&id=371d7b0a&scoped=true"
import script from "./luckygiftorder.vue?vue&type=script&lang=js"
export * from "./luckygiftorder.vue?vue&type=script&lang=js"
import style0 from "./luckygiftorder.vue?vue&type=style&index=0&id=371d7b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371d7b0a",
  null
  
)

export default component.exports